import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from 'react-router-dom';
import {VIEWS} from "../../helpers/consts";

import Select from "../search/Select";
import SwitchControl from "../switch/SwitchControl";
import SVGIcon from "../svg/SVGIcon";
import Search from "../search/Search";

import {setSettingsOpenAction} from "../../actions/SettingsAction";

import "./InfoBox.css";

class InfoBox extends Component {

  constructor(props) {
    super(props);
    this.onClickToggle = this.onClickToggle.bind(this);
    this.setSettingsOpen = this.setSettingsOpen.bind(this);
  }

  onClickToggle(e) {
    e.preventDefault();
    const {nav} = this.props;
    this.setSettingsOpen(!nav.settings);
  }

  setSettingsOpen(open) {
    this.props.setSettingsOpenAction(open);
  }

  render() {
    const {occupationMeasure, nav, isMobile, hashParts} = this.props;
    const selected = hashParts;

    return (
      <div id="fow-info-box-placeholder">
        <div id="fow-info-box" className={`fow-info-box-${nav.fixed ? 'fixed' : 'static'}`}>
          <div className="fow-inner-container">
            <div id="fow-info-box-content" className={`fow-row ${isMobile && !nav.fixed ? 'fow-row-wrap' : 'fow-row-nowrap'}`}>
              {selected.view === VIEWS.OCCUPATIONAL &&
                <>
                  <div className={`fow-col fow-col-1-4 fow-lg-col-1-3 fow-md-col-1-2 fow-sm-col-${isMobile && !nav.fixed ? '5-6' : '6-6'}`}>
                    <div className="fow-info-box-single-title">
                      <SVGIcon stroke="#051C2C" width="30" strokeWidth="1.5" name="binoculars" /><span className="fow-info-box-title fow-font-text fow-font-size-sm">Select an occupation</span>
                    </div>
                    <Select optionsKey="Occupations" />
                  </div>
                  <div className={`fow-col-1-6 fow-info-box-settings-icon fow-info-box-${isMobile && !nav.fixed ? 'show' : 'hide'}`} onClick={(e) => this.onClickToggle(e)}>
                    <SVGIcon stroke="#051C2C" width="40" strokeWidth="1.5" name="settings" />
                  </div>
                </>
              }
              {selected.view === VIEWS.EMPLOYMENT &&
                <>
                  <div className={`fow-col fow-col-5-6 fow-info-box-settings-icon fow-info-box-${isMobile && !nav.fixed ? 'show' : 'hide'}`} onClick={(e) => this.onClickToggle(e)}>
                    <h3 className="fow-font-text fow-font-size-lg">Labor Market Outcomes</h3>
                  </div>
                  <div className={`fow-col-1-6 fow-info-box-settings-icon fow-info-box-${isMobile && !nav.fixed ? 'show' : 'hide'}`} onClick={(e) => this.onClickToggle(e)}>
                    <SVGIcon stroke="#051C2C" width="40" strokeWidth="1.5" name="settings" />
                  </div>
                </>
              }
              {selected.view === VIEWS.REGIONAL_CLUSTER &&
                <>
                  <div className="fow-col fow-col-1-4 fow-lg-col-1-3 fow-md-col-2-3 fow-sm-col-1">
                    <div className="fow-info-box-single-title">
                      <SVGIcon stroke="#051C2C" width="30" height="20" name="binoculars" /><span className="fow-info-box-title fow-font-text fow-font-size-sm">Select a cluster or a region</span>
                    </div>
                    <Search />
                  </div>
                </>
              }

              {selected.view === VIEWS.OCCUPATIONAL &&
                <div className={`fow-col-3-4 fow-md-col-1 fow-sm-col-1 fow-info-box-${nav.fixed || (isMobile && !nav.settings) ? 'hide' : 'show'}`}>
                  <div className="fow-row fow-sm-row-to-col">
                    <div className={`fow-col fow-col-1-3 fow-sm-col-1`}>
                      <SwitchControl label="Measure" optionsKey="measure_occ" options={[{key: "values", value: "Values"}, {key: "delta", value: "Delta"}]} />
                    </div>
                    <div className={`fow-col fow-col-1-3 fow-sm-col-1`}>
                      <SwitchControl label="Perspective" optionsKey="perspective_occ" options={[{key: "today", value: "Today"}, {key: "future", value: "Future"}]} disabled={occupationMeasure.key === "delta"} />
                    </div>
                    <div className={`fow-col fow-col-1-3 fow-sm-col-1`}>
                      <SwitchControl label="Share" optionsKey="share_occ" options={[{key: "absolute", value: "Absolute"}, {key: "relative", value: "Relative"}]} disabled={occupationMeasure.key === "delta"} />
                    </div>
                  </div>
                </div>
              }

              {selected.view === VIEWS.EMPLOYMENT &&
                <div className={`fow-col-1-2 fow-xl-col-2-3 fow-lg-col-1 fow-md-col-1 fow-sm-col-1 fow-info-box-${nav.fixed || (isMobile && !nav.settings) ? 'hide' : 'show'}`}>
                  <div className="fow-row fow-sm-row-to-col">
                    <div className={`fow-col fow-col-1-2 fow-sm-col-1`}>
                      <SwitchControl label="Perspective" optionsKey="perspective" options={[{key: "today", value: "Today"}, {key: "future", value: "Future"}]} />
                    </div>
                    <div className={`fow-col fow-col-1-2 fow-sm-col-1`}>
                        <SwitchControl label="Measure" optionsKey="measure" options={[{key: "job_growth", value: "Job Growth"}, {key: "employment_rate", value: "Employment Rate"}]} />
                    </div>
                  </div>
                </div>
              }

              {selected.view === VIEWS.REGIONAL_CLUSTER &&
                <></>
              }

            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    occupationMeasure: state.settings.switch.measure_occ,
    hashParts: state.settings.hashParts,
    nav: state.settings.nav,
    isMobile: state.settings.window.width < 768
  };
};
const mapDispatchToProps = dispatch => ({
  setSettingsOpenAction: open => dispatch(setSettingsOpenAction(open)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InfoBox));
